import { twJoin } from 'tailwind-merge';

import { Box } from '@/components/ui/box';
import { Card } from '@/components/ui/card';
import { Divider } from '@/components/ui/divider';
import { HStack } from '@/components/ui/hstack';
import { Skeleton } from '@/components/ui/skeleton';
import { VStack } from '@/components/ui/vstack';
import { useIsCompactLayout } from '@/hooks/useResponsiveLayout';

/**
 * Placeholder shown while an inquiry list is fetching.
 *
 * Carries `inbox-loading` so end-to-end tests can tell "still loading" apart from
 * "loaded and empty". Without it the loading list matches neither an inquiry card nor
 * the empty state, and a list slower than the element timeout reads as a hung page
 * rather than a pending one.
 */
export function MessageCardSkeleton() {
  const isCompactLayout = useIsCompactLayout();

  return (
    <VStack testID="inbox-loading">
      {[...Array(3)].map((_, index) => (
        <Box key={index}>
          <Card size="lg" className="m-0 p-3">
            <HStack space="lg">
              <Skeleton className={isCompactLayout ? 'h-12 w-12' : 'h-8 w-8'} variant="circular" />

              <VStack className="flex-1 gap-2">
                <Skeleton className="h-5 w-1/3" />

                <Skeleton className="h-5 w-2/3" />

                <Skeleton className={twJoin('w-full', isCompactLayout ? 'h-5' : 'h-10')} />
              </VStack>
            </HStack>
          </Card>

          <Divider />
        </Box>
      ))}
    </VStack>
  );
}
